export enum RideStationCategory {
  HomeStation = "HomeStation",
  PassengerStation = "PassengerStation",
  WorkStation = "WorkStation",
  OfficialStation = "OfficialStation",
}
